import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./tabs.css.ts.vanilla.css-mistica.js";
var f = "_1y2v1nfhj _1y2v1nfhf _1y2v1nfl6 _1y2v1nfm0 _1y2v1nfiq", e = "lgofm1q", y = "lgofm14", _ = "lgofm13 _1y2v1nfjv _1y2v1nfi7 _1y2v1nfhe", a = "lgofm10", r = "lgofm11", l = {
    default: "lgofm1a",
    inverse: "lgofm1b"
}, o = {
    noSelected: "_1y2v1nf28",
    noSelectedInverse: "_1y2v1nf29",
    selected: "lgofm1g",
    selectedInverse: "lgofm1h",
    selectedAnimating: "lgofm1i",
    selectedAnimatingInverse: "lgofm1j"
}, t = {
    default: "lgofm17 _1y2v1nfaa _1y2v1nfbj _1y2v1nfhl _1y2v1nfi2 _1y2v1nfhz _1y2v1nfht _1y2v1nfjj _1y2v1nfjv _1y2v1nf7c",
    fullWidth: "lgofm19 lgofm17 _1y2v1nfaa _1y2v1nfbj _1y2v1nfhl _1y2v1nfi2 _1y2v1nfhz _1y2v1nfht _1y2v1nfjj _1y2v1nfjv _1y2v1nf7c"
}, i = "_1y2v1nfjv _1y2v1nfi7 _1y2v1nfhk";
export { f as animatedLine, e as icon, y as inner, _ as outer, a as outerBorder, r as outerBorderInverse, l as tabHover, o as tabSelectionVariants, t as tabVariants, i as tabsContainer };
